export default __webpack_public_path__ + "static/home-hero-vactor-25a708dd86a692df625c6fd6fe58c557.webp";